import React from 'react';

// TODO Add equivalent icon to DS and use here
import StarIconComponent from 'mdi-react/StarIcon';

import * as S from './styles';

type Props = {
  className?: string;
  type: 'product' | 'store';
};

const ReviewCardPlaceholder = ({ className, type = 'product' }: Props) => {
  return (
    <S.Card className={className}>
      <S.Rating>
        {type === 'product' && <StarIconComponent size={40} />}
        {type === 'store' && <S.Smiley size={40} ariaLabel="" />}
      </S.Rating>
      <S.Text width={30} />
      <S.Text width={100} />
      <S.Text width={90} />
      <S.Text width={70} />
    </S.Card>
  );
};

export default ReviewCardPlaceholder;
